/* gc-entitle.jsx — vyerna för planspärr, trappa och villkorsgrind.
   EntLock: gråad funktion bakom en panel med Uppgradera (K2/K3/K4, 15/9).
   LockedPage: EN sida som tar access + reason (trappan T2, 20/9) och väljer
   rubrik, styrningsbesked, nedräkning och knapp. Ersätter BlockedPage.
   TermsPage: godkännandesidan (villkor K3, 20/9). Samma skal som LockedPage.
   Ingen av dem hämtar data; allt går via window.HemsEnt. */

function EntUpgradeBtn({ label = 'Uppgradera' }){
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState(null);
  /* v928 (installatörscentret leverans 2, svar 5): installatören betalar ⇒ ingen portal att öppna, ingen knapp. */
  const [bm, setBm] = React.useState(() => window.HemsEnt && window.HemsEnt.billingMode ? window.HemsEnt.billingMode() : null);
  React.useEffect(() => { const on = () => setBm(window.HemsEnt && window.HemsEnt.billingMode ? window.HemsEnt.billingMode() : null); window.addEventListener('hems:entitlements', on); return () => window.removeEventListener('hems:entitlements', on); }, []);
  if (bm === 'installator') return null;
  const go = async () => {
    setErr(null); setBusy(true);
    const r = await window.HemsEnt.openPortal();
    if (!r.ok) setErr(r.error);
    setBusy(false);
  };
  return (
    <div className="flex flex-col items-center gap-2">
      <button type="button" onClick={go} disabled={busy}
        className="rounded-xl border border-sky-400/40 bg-sky-400/10 px-5 py-2.5 text-sm font-semibold text-sky-200 transition-colors hover:bg-sky-400/20 disabled:opacity-60">
        {busy ? 'Öppnar…' : label}
      </button>
      {err && <div className="text-[12px] text-slate-400">{err}</div>}
    </div>
  );
}

/* Gråat innehåll bakom panelen: konfigurationen syns kvar så kunden ser vad
   hen går miste om (André 15/9), men inget går att röra. */
function EntLock({ text, children }){
  return (
    <div className="relative">
      <div aria-hidden="true" className="pointer-events-none select-none" style={{ filter:'grayscale(1) saturate(.15)', opacity:.35 }}>
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center px-4" style={{ background:'linear-gradient(180deg, rgba(10,15,26,.35), rgba(10,15,26,.82) 45%)' }}>
        <div className="flex max-w-sm flex-col items-center gap-3 rounded-2xl border border-slate-700/70 bg-slate-950/85 px-6 py-6 text-center">
          <span className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-700 bg-slate-900 text-slate-300">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="4" y="10.5" width="16" height="10" rx="2.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/>
            </svg>
          </span>
          <div className="text-[15px] font-semibold text-slate-100">{text}</div>
          <EntUpgradeBtn/>
        </div>
      </div>
    </div>
  );
}

function EntLockEmpty({ text }){
  return (
    <EntLock text={text}>
      <div className="rounded-2xl border border-slate-800 bg-slate-900/40" style={{ minHeight: 320 }}/>
    </EntLock>
  );
}

/* Gemensamt skal: märke, rubrik, brödtext, innehåll, Logga ut. */
function EntLogout(){
  if (window.HEMS_VISIT && window.HEMS_VISIT()) { window.HEMS_VISIT_LOGOUT(); return; }
  ['hems_session_token', 'hems_user_email', 'hems_user_name', 'hems_user_id']
    .forEach(k => { try { localStorage.removeItem(k); } catch(_){} });
  window.location.href = 'login.html';
}
/* Din supportkod på spärrsidan (backend 23/9, S2): ur samma /me. Inget när fältet saknas. */
function EntSupportCode(){
  const E = window.HemsEnt;
  const [code, setCode] = React.useState(() => { const m = E && E.me(); return (m && m.support_code) || null; });
  React.useEffect(() => { const on = () => { const m = E && E.me(); if (m && m.support_code) setCode(m.support_code); }; window.addEventListener('hems:entitlements', on); return () => window.removeEventListener('hems:entitlements', on); }, []);
  if (!code) return null;
  return (
    <div className="text-[13.5px] text-slate-400">Din supportkod: <span className="font-semibold text-slate-100" style={{ fontFamily:'"Geist Mono", ui-monospace, SFMono-Regular, Menlo, monospace', fontSize:18, letterSpacing:'.16em', fontVariantNumeric:'tabular-nums' }}>{code}</span> <span className="text-slate-500">– uppge den när du kontaktar oss.</span></div>
  );
}
function EntShell({ title, lede, children, wide }){
  return (
    <div className="gc-root min-h-screen text-slate-200" style={{ background:'#0a0f1a', fontFamily:'Inter, system-ui, sans-serif' }}>
      <div className={`mx-auto flex w-full flex-col gap-7 px-4 py-10 lg:py-16 ${wide ? 'max-w-3xl' : 'max-w-xl'}`}>
        <div className="flex items-center gap-2">
          <img src="gravio-mark.svg" alt="" className="h-8 w-8 shrink-0"/>
          <span className="flex flex-col leading-none">
            <span className="text-[15px] font-semibold text-slate-50" style={{ fontFamily:'Lora, Georgia, serif', letterSpacing:'-.01em' }}>Gravio HEMS</span>
            <span className="mt-0.5 text-[7.5px] uppercase text-slate-500" style={{ fontFamily:'ui-monospace, monospace', letterSpacing:'.18em' }}>AI Energy Solutions</span>
          </span>
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-50 sm:text-3xl">{title}</h1>
          {lede && <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-slate-400" style={{ textWrap:'pretty' }}>{lede}</p>}
        </div>
        {children}
        {/* v928 (installatörscentret leverans 1, avsnitt 7): kunden ska kunna ta bort installatörens åtkomst också när dashboarden är låst. */}
        {window.HemsInstallerRow && <window.HemsInstallerRow variant="locked"/>}
        <EntSupportCode/>
        <button type="button" onClick={EntLogout}
          className="self-start text-[13px] font-semibold text-slate-500 transition-colors hover:text-slate-300">Logga ut</button>
      </div>
    </div>
  );
}

/* Kryssruta med länkade dokument (K3/K5). Länkarna öppnas i ny flik så
   rutan inte tappas när kunden läst klart. URL:erna ur /me när de finns. */
function EntCheck({ checked, onChange, children, id }){
  return (
    <label htmlFor={id} className="flex cursor-pointer items-start gap-3 text-[14px] leading-relaxed text-slate-300">
      <input id={id} type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)}
        className="mt-1 h-4 w-4 shrink-0 cursor-pointer accent-sky-400"/>
      <span style={{ textWrap:'pretty' }}>{children}</span>
    </label>
  );
}
function EntTermsLabel(){
  const E = window.HemsEnt;
  const a = 'underline decoration-slate-600 underline-offset-2 hover:text-slate-50';
  return (
    <>Jag har läst och godkänner <a className={a} href={E.termsUrl()} target="_blank" rel="noopener">användarvillkoren</a> och har tagit del av <a className={a} href={E.privacyUrl()} target="_blank" rel="noopener">integritetspolicyn</a></>
  );
}

/* Plankort. onPick(plan, interval). Samma kort för subscription_required
   (checkout) och subscription_ended (reactivate); texten "Första månaden
   gratis" hör inte hit — Checkout debiterar direkt. */
function EntPlanCard({ plan, onPick, busy, err, disabled }){
  const [ival, setIval] = React.useState('month');
  const yearly = plan.year && ival === 'year';
  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-slate-800 bg-slate-900/40 px-4 py-4">
      <div>
        <div className="text-[15px] font-semibold text-slate-100">{plan.name}</div>
        <div className="mt-0.5 text-[12px] text-slate-500">{plan.tag}</div>
      </div>
      <div className="flex items-baseline gap-1.5">
        <b className="text-[26px] font-bold leading-none text-slate-50 tabular-nums">{yearly ? plan.year : plan.month}</b>
        <span className="text-[12px] text-slate-400">{yearly ? 'kr / år' : 'kr / mån'}</span>
      </div>
      <div className="text-[11px] text-slate-500">inkl. moms</div>
      <ul className="flex flex-col gap-1.5 text-[12.5px] leading-snug text-slate-400">
        {plan.rows.map((r, i) => <li key={i}>{r}</li>)}
      </ul>
      {plan.year && (
        <div className="flex gap-1 rounded-lg border border-slate-800 bg-slate-950/60 p-1" role="radiogroup" aria-label="Betalningsintervall">
          {[['month', 'Månad'], ['year', 'År']].map(([v, l]) => (
            <button key={v} type="button" onClick={() => setIval(v)} aria-pressed={ival === v}
              className={`flex-1 rounded-md px-2 py-1 text-[12px] font-semibold transition-colors ${ival === v ? 'bg-slate-800 text-slate-100' : 'text-slate-500 hover:text-slate-300'}`}>{l}</button>
          ))}
        </div>
      )}
      {plan.year && ival === 'year' && <div className="text-[11.5px] text-slate-500">Köp 12 månader, betala för 11</div>}
      <button type="button" onClick={() => onPick(plan.id, ival)} disabled={!!busy || disabled}
        className="mt-auto rounded-xl border border-sky-400/40 bg-sky-400/10 px-4 py-2.5 text-[13.5px] font-semibold text-sky-200 transition-colors hover:bg-sky-400/20 disabled:cursor-not-allowed disabled:opacity-40">
        {busy === plan.id ? 'Öppnar…' : `Välj ${plan.name}`}
      </button>
      {err && <div className="text-[12px] text-slate-400">{err}</div>}
    </div>
  );
}

/* Styrningsbeskedet (T3) + nedräkningarna (T4). Sidans viktigaste mening:
   ligger FÖRE plankorten. Lugn rad, ingen varningspanel. */
function EntControlNotice({ ent }){
  const E = window.HemsEnt;
  const c = E.daysPhrase(ent.days_until_control_stops, 'for');
  const d = E.daysPhrase(ent.days_until_data_deleted, 'in');
  let main = null, sub = null;
  if (ent.access === 'dash_locked'){
    main = c ? `HEMS styr din anläggning som vanligt ${c}.` : 'HEMS styr din anläggning som vanligt.';
    if (ent.days_until_control_stops === 0) main = 'HEMS styr din anläggning som vanligt i dag. Sedan upphör styrningen.';
    sub = 'Batteriet, bilen och lasterna följer planen även om den här sidan är stängd.';
  } else if (ent.access === 'stopped'){
    main = 'HEMS har slutat styra din anläggning.';
    /* D3: data sparas tolv månader efter avtalets slut. Nedräkningen visas
       bara när backend skickat ett tal; null ⇒ ingen raderingstext. */
    const n = ent.days_until_data_deleted;
    sub = n == null ? 'Dina data och inställningar finns kvar i tolv månader, så du kan fortsätta där du var om du kommer tillbaka.'
        : n === 0 ? 'Dina data tas bort i dag.' : n === 1 ? 'Dina data finns kvar till i morgon.' : `Dina data finns kvar i ${n} dagar.`;
  } else if (ent.access === 'purged'){
    main = 'HEMS har slutat styra din anläggning.';
    sub = 'Dina data har tagits bort.';
  }
  if (!main) return null;
  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/40 px-5 py-4">
      <div className="text-[16px] font-semibold text-slate-50" style={{ textWrap:'pretty' }}>{main}</div>
      {sub && <div className="mt-1 text-[13.5px] text-slate-400" style={{ textWrap:'pretty' }}>{sub}</div>}
      {ent.access === 'dash_locked' && d && (
        <div className="mt-1 text-[13.5px] text-slate-400">Dina data raderas {d} om du inte förnyar. Fram till dess finns allt kvar.</div>
      )}
    </div>
  );
}

/* Spärrsidan — ett läge per reason (2.2). */
function LockedPage({ ent }){
  const E = window.HemsEnt;
  const e = ent || E.get();
  const [busy, setBusy] = React.useState(null);
  const [err, setErr] = React.useState(null);
  const [termsOk, setTermsOk] = React.useState(false);
  const [deliverOk, setDeliverOk] = React.useState(false);
  const reason = e.reason;

  const pickReactivate = async (plan, interval) => {
    setErr(null); setBusy(plan);
    const r = await E.reactivate(plan, interval);
    if (!r.ok) setErr({ plan, msg:r.error });
    setBusy(null);
  };
  const pickCheckout = async (plan, interval) => {
    setErr(null); setBusy(plan);
    const r = await E.checkout(plan, interval, { terms_accepted:termsOk, delivery_start_now:deliverOk });
    if (!r.ok) setErr({ plan, msg:r.error });
    setBusy(null);
  };

  /* v928 (installatörscentret leverans 2, svar 4): skyddsnät när villkorssidan inte tar emot kunden. Leder till godkännandet, inte till planvalet. */
  if (reason === 'terms_pending') return <TermsPage pending/>;

  /* payment_failed hit FÖRST efter varningsperioden (rev 2 D1): access är då
     stopped och styrningen har upphört. Under perioden är dashboarden öppen
     med PaymentBanner. */
  if (reason === 'payment_failed'){
    return (
      <EntShell title="Vi kunde inte dra betalningen"
        lede={`Dragningen för ${E.PLAN_NAME[e.plan] ? `${E.PLAN_NAME[e.plan]}-abonnemanget` : 'ditt abonnemang'} gick inte igenom, och styrningen har nu stoppats. Det kan bero på att kortet löpt ut eller bytts. Uppdatera betalsättet så startar allt igen med dina inställningar.`}>
        <EntControlNotice ent={e}/>
        <div className="flex flex-col items-start gap-2">
          <EntUpgradeBtn label="Uppdatera betalsättet"/>
          <div className="text-[12.5px] text-slate-500">Öppnar Stripes kundportal, där kortet byts.</div>
        </div>
      </EntShell>
    );
  }

  if (reason === 'subscription_required'){
    const ready = termsOk && deliverOk;
    return (
      <EntShell wide title="Välj ditt abonnemang"
        lede="Ditt konto finns kvar med alla inställningar. Välj en nivå så fortsätter du där du var. Betalningen sker hos Stripe med den e-post du är inloggad med.">
        <EntControlNotice ent={e}/>
        <div className="flex flex-col gap-3 rounded-2xl border border-slate-800 bg-slate-900/40 px-5 py-4">
          <EntCheck id="lk-terms" checked={termsOk} onChange={setTermsOk}><EntTermsLabel/></EntCheck>
          <EntCheck id="lk-deliver" checked={deliverOk} onChange={setDeliverOk}>{E.DELIVERY_LABEL}</EntCheck>
          {!ready && <div className="text-[12px] text-slate-500">Kryssa båda rutorna för att kunna välja en nivå.</div>}
        </div>
        <div className="grid gap-3 sm:grid-cols-3">
          {E.PLANS.map(p => (
            <EntPlanCard key={p.id} plan={p} onPick={pickCheckout} busy={busy} disabled={!ready}
              err={err && err.plan === p.id ? err.msg : null}/>
          ))}
        </div>
      </EntShell>
    );
  }

  /* subscription_ended (v404) — plankort via reactivate. */
  return (
    <EntShell wide title="Din prenumeration har gått ut"
      lede="Välj en nivå för att fortsätta. Betalningen sker hos Stripe och du kommer tillbaka hit när den är klar.">
      <EntControlNotice ent={e}/>
      <div className="grid gap-3 sm:grid-cols-3">
        {E.PLANS.map(p => (
          <EntPlanCard key={p.id} plan={p} onPick={pickReactivate} busy={busy}
            err={err && err.plan === p.id ? err.msg : null}/>
        ))}
      </div>
    </EntShell>
  );
}

/* Godkännandesidan (K3). Helsida före all annan rendering. En kryssruta,
   knappen inaktiv tills den är kryssad. Ingen väg förbi utom Logga ut. */
function TermsPage({ pending }){
  const E = window.HemsEnt;
  const t = E.terms();
  const [ok, setOk] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const first = !t.accepted_version;
  /* v924 (backend 24/10, punkt 4): under Visa som kunden godkänner admin aldrig åt kunden. Ingen kryssruta, ingen knapp, inget anrop. */
  const visit = !!(window.HEMS_VISIT && window.HEMS_VISIT());
  const go = async () => {
    if (visit) return;
    setErr(null); setBusy(true);
    const r = await E.acceptTerms();
    if (!r.ok) { setErr(r.error); setBusy(false); }
  };
  return (
    <EntShell title={pending ? 'Godkänn användarvillkoren' : first ? 'Godkänn villkoren för att fortsätta' : 'Villkoren har uppdaterats'}
      lede={pending ? 'Godkänn användarvillkoren så börjar hemmet styras.' : first
        ? 'Innan du använder HEMS behöver du godkänna användarvillkoren. Din anläggning styrs som vanligt under tiden.'
        : `Version ${t.current_version} av användarvillkoren gäller nu. Godkänn den nya versionen för att fortsätta. Din anläggning styrs som vanligt under tiden.`}>
      <div className="flex flex-col gap-4 rounded-2xl border border-slate-800 bg-slate-900/40 px-5 py-5">
        <div className="text-[12px] text-slate-500">Användarvillkor för HEMS och Integritetspolicy · PowerGravio AB · version {t.current_version}</div>
        {visit ? <div className="text-sm text-slate-300">{(window.HEMS_VISIT_TEXT ? window.HEMS_VISIT_TEXT() : 'Görs i admin.')}</div> : <>
        <EntCheck id="terms-ok" checked={ok} onChange={setOk}><EntTermsLabel/></EntCheck>
        <div className="flex flex-col items-start gap-2">
          <button type="button" onClick={go} disabled={!ok || busy}
            className="rounded-xl border border-sky-400/40 bg-sky-400/10 px-5 py-2.5 text-sm font-semibold text-sky-200 transition-colors hover:bg-sky-400/20 disabled:cursor-not-allowed disabled:opacity-40">
            {busy ? 'Sparar…' : 'Godkänn och fortsätt'}
          </button>
          {err && <div className="text-[12px] text-slate-400">{err}</div>}
        </div></>}
      </div>
    </EntShell>
  );
}

/* Banner vid utebliven betalning (rev 2 D1): dashboarden är öppen, styrningen
   pågår, kunden ska se problemet och kunna laga det. Nedräkning + datum ur
   backend (days_until_control_stops, control_stops_date), aldrig uträknat här.
   Lugn ton; närmare slutet (≤ 3 dagar) tydligare kant, men ingen röd panel. */
/* v928 (installatörscentret leverans 2, 5.1): planvalet ur bannern efter att installatören tagits bort. Utan tidigare Stripe-kund
   (has_subscription falskt) checkout med kryssrutorna, annars reactivate. Inget om gratismånad: köpet startar utan en ny. */
/* v943 (backend 28/10, IC-P18): checkoutOnly för ett hem med licens. Då alltid /billing/checkout med kryssrutorna, aldrig reactivate (409). */
function EntPlanPicker({ onClose, checkoutOnly }){
  const E = window.HemsEnt;
  const me = (E && E.me()) || {};
  const again = !checkoutOnly && me.has_subscription === true;
  const [busy, setBusy] = React.useState(null), [err, setErr] = React.useState(null), [termsOk, setTermsOk] = React.useState(false), [deliverOk, setDeliverOk] = React.useState(false);
  const ready = again || (termsOk && deliverOk);
  const pick = async (plan, interval) => {
    setErr(null); setBusy(plan);
    const r = again ? await E.reactivate(plan, interval) : await E.checkout(plan, interval, { terms_accepted:termsOk, delivery_start_now:deliverOk });
    if (!r.ok) setErr({ plan, msg:r.error });
    setBusy(null);
  };
  return (
    <div className="mt-3 flex flex-col gap-3 rounded-2xl border border-slate-700 bg-slate-900/60 px-4 py-4">
      <div className="flex items-center justify-between gap-3"><div className="text-[14px] font-semibold text-slate-50">Välj abonnemang</div>
        <button type="button" onClick={onClose} className="rounded-lg border border-slate-700 px-3 py-1.5 text-[13px] text-slate-300 hover:text-slate-100">Stäng</button></div>
      <div className="text-[12.5px] text-slate-400">Betalningen sker hos Stripe med den e-post du är inloggad med.</div>
      {!again && <div className="flex flex-col gap-3">
        <EntCheck id="ir-terms" checked={termsOk} onChange={setTermsOk}><EntTermsLabel/></EntCheck>
        <EntCheck id="ir-deliver" checked={deliverOk} onChange={setDeliverOk}>{E.DELIVERY_LABEL}</EntCheck>
        {!ready && <div className="text-[12px] text-slate-500">Kryssa båda rutorna för att kunna välja en nivå.</div>}
      </div>}
      <div className="grid gap-3 sm:grid-cols-3">{E.PLANS.map(p => <EntPlanCard key={p.id} plan={p} onPick={pick} busy={busy} disabled={!ready} err={err && err.plan === p.id ? err.msg : null}/>)}</div>
    </div>
  );
}
/* v941 (licenser): license_ending och license_grace. Knappen för eget abonnemang bara när GET /api/installator ger licens.kan_valja_eget. */
function LicenseBanner({ ent }){
  const E = window.HemsEnt;
  const w = E && E.licenseEnding ? E.licenseEnding(ent) : null;
  const [open, setOpen] = React.useState(false), [lic, setLic] = React.useState(null);
  React.useEffect(() => { if (!w || !window.hemsInstallerInfo) return; let on = true; window.hemsInstallerInfo().then((b) => { if (on) setLic(b && b.licens && typeof b.licens === 'object' ? b.licens : null); }, () => {}); return () => { on = false; }; }, [!!w]);
  if (!w) return null;
  const own = !!(lic && lic.kan_valja_eget === true);
  return (
    <div>
      <div className={`mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl border px-4 py-3 ${w.urgent ? 'border-amber-400/50 bg-amber-400/10' : 'border-slate-700 bg-slate-900/60'}`} role="status">
        <div className="min-w-0 flex-1">
          <div className="text-[14px] font-semibold text-slate-50" style={{ textWrap:'pretty' }}>{w.text}</div>
          <div className="mt-0.5 text-[12.5px] text-slate-400">{own ? 'Välj ett eget abonnemang på samma konto, så fortsätter allt utan avbrott.' : 'Kontakta din installatör om att förlänga licensen.'}</div>
        </div>
        {own && !open && <button type="button" onClick={() => setOpen(true)}
          className="shrink-0 rounded-xl border border-sky-400/40 bg-sky-400/10 px-4 py-2 text-[13px] font-semibold text-sky-200 transition-colors hover:bg-sky-400/20">Välj eget abonnemang</button>}
      </div>
      {own && open && <EntPlanPicker checkoutOnly onClose={() => setOpen(false)}/>}
    </div>
  );
}
function InstallerRemovedBanner({ ent }){
  const E = window.HemsEnt;
  const w = E && E.installerRemoved ? E.installerRemoved(ent) : null;
  const [open, setOpen] = React.useState(false), [lic, setLic] = React.useState(false);
  React.useEffect(() => { if (!w || !window.hemsInstallerInfo) return; let on = true; window.hemsInstallerInfo().then((b) => { if (on) setLic(!!(b && b.licens)); }, () => {}); return () => { on = false; }; }, [!!w]);
  if (!w) return <LicenseBanner ent={ent}/>;
  return (
    <div>
      <div className={`mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl border px-4 py-3 ${w.urgent ? 'border-amber-400/50 bg-amber-400/10' : 'border-slate-700 bg-slate-900/60'}`} role="status">
        <div className="min-w-0 flex-1">
          <div className="text-[14px] font-semibold text-slate-50" style={{ textWrap:'pretty' }}>{w.text}</div>
          <div className="mt-0.5 text-[12.5px] text-slate-400">Välj ett abonnemang innan dess, så fortsätter allt utan avbrott.</div>
        </div>
        {!open && <button type="button" onClick={() => setOpen(true)}
          className="shrink-0 rounded-xl border border-sky-400/40 bg-sky-400/10 px-4 py-2 text-[13px] font-semibold text-sky-200 transition-colors hover:bg-sky-400/20">Välj abonnemang</button>}
      </div>
      {open && <EntPlanPicker checkoutOnly={lic} onClose={() => setOpen(false)}/>}
    </div>
  );
}
function PaymentBanner({ ent }){
  const E = window.HemsEnt;
  const w = E && E.paymentWarning(ent);
  const [busy, setBusy] = React.useState(false);
  const [err, setErr] = React.useState(null);
  if (!w) return <InstallerRemovedBanner ent={ent}/>;
  const go = async () => {
    setErr(null); setBusy(true);
    const r = await E.openPortal();
    if (!r.ok) setErr(r.error);
    setBusy(false);
  };
  return (
    <div className={`mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl border px-4 py-3 ${w.urgent ? 'border-amber-400/50 bg-amber-400/10' : 'border-slate-700 bg-slate-900/60'}`} role="status">
      <div className="min-w-0 flex-1">
        <div className="text-[14px] font-semibold text-slate-50" style={{ textWrap:'pretty' }}>{w.text}</div>
        <div className="mt-0.5 text-[12.5px] text-slate-400">Fram till dess styr HEMS som vanligt. Dashboarden och inställningarna är öppna.{err ? ` ${err}` : ''}</div>
      </div>
      {!(E.paidByInstaller && E.paidByInstaller()) && <button type="button" onClick={go} disabled={busy}
        className="shrink-0 rounded-xl border border-sky-400/40 bg-sky-400/10 px-4 py-2 text-[13px] font-semibold text-sky-200 transition-colors hover:bg-sky-400/20 disabled:opacity-60">
        {busy ? 'Öppnar…' : 'Uppdatera betalsättet'}
      </button>}
    </div>
  );
}

/* Grinden i rot (K3 + T2): villkor först, sedan spärren, sedan appen.
   Lyssnar på hems:entitlements så 402/403 mitt i sessionen byter vy — och
   App avmonteras, så pollningen stannar. */
function EntGate({ children }){
  const E = window.HemsEnt;
  const [, force] = React.useState(0);
  React.useEffect(() => {
    if (!E) return;
    const on = () => force(n => n + 1);
    window.addEventListener('hems:entitlements', on);
    return () => window.removeEventListener('hems:entitlements', on);
  }, []);
  /* v928: grinden i entitlements.js. Under installatörens besök hos en ny kund visas varken villkorssidan eller spärrsidan för
     terms_pending, utan en rad överst (installatörscentret leverans 2, 5.3). */
  const g = E ? (E.gate ? E.gate() : (E.termsRequired() ? 'terms' : E.locked() ? 'locked' : null)) : null;
  if (g === 'terms') return <TermsPage/>;
  if (g === 'locked') return <LockedPage ent={E.get()}/>;
  const pend = E && E.ptrVisit && E.ptrVisit() && (E.get().reason === 'terms_pending' || E.termsRequired());
  if (pend) return <><div className="gc-root" role="status" style={{ background:'#3B1A47', color:'#F5D0FE', borderBottom:'1px solid rgba(232,121,249,.45)', padding:'10px 14px', fontSize:14, lineHeight:1.45, textAlign:'center', textWrap:'pretty' }}>Kunden har inte godkänt villkoren än. Hemmet styrs inte förrän det är gjort.</div>{children}</>;
  return children;
}

const BlockedPage = LockedPage;   // bakåtkompatibelt namn
Object.assign(window, { EntLock, EntLockEmpty, EntUpgradeBtn, EntPlanCard, EntCheck, EntTermsLabel, EntControlNotice, LockedPage, TermsPage, EntGate, BlockedPage, PaymentBanner, EntPlanPicker, LicenseBanner, InstallerRemovedBanner });
